/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const AreaDetailPage = lazyLoad(
  () => import('./index'),
  module => module.AreaDetailPage
);
